import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";

export const LiveFeedbackSendButton = ({ disabled, onSendAnswers }) => {
  return (
    <GridItem gridRow="3" gridColumn="1 / span 8" marginTop={6}>
      <Button size="medium" action={onSendAnswers} disabled={disabled}>
        <Text size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
          <FormattedMessage id="live_feedback_modal.send_feedback_button" />
        </Text>
      </Button>
    </GridItem>
  );
};

LiveFeedbackSendButton.propTypes = {
  disabled: PropTypes.bool,
  onSendAnswers: PropTypes.func.isRequired,
};

LiveFeedbackSendButton.defaultProps = {
  disabled: false,
};

export default LiveFeedbackSendButton;
